import React from 'react';
import styled from 'styled-components';
import bg_chat from '../../img/bg_chat.jpg';
import chat from '../../img/chat.png';

const Title = styled.h2`
	font-weight: 700;
	font-size: 24px;
	line-height: 28px;
	color: #000000;
	margin-bottom: 20px;
`;

const Container = styled.div`
	width: 100%;
	background: linear-gradient(84.98deg, #effcff 9.74%, #fff1f1 96.25%);
	backdrop-filter: blur(4.53047px);
	background-position: center;
	background-size: cover;
	padding: 20px;
	color: #000000;
	text-align: center;
	border-radius: 10px;

	& img {
		width: 100%;
		max-width: 173px;
		margin-bottom: 14px;
	}

	& h3 {
		font-weight: 700;
		font-size: 24px;
		line-height: 24px;
		letter-spacing: 0.37px;
		margin-bottom: 10px;
	}

	& p {
		font-size: 14px;
		line-height: 18px;
	}
`;

export const Coaching = () => {
	return (
		<>
			<Title>Stay motivated with an inspiring coach</Title>
			<Container>
				<img src={chat} alt='chat' />
				<h3>1:1 Chat Coaching</h3>
				<p>
					Our team of nutrition and fitness experts will stay connected with you throughout the
					program, offering continuous support and guidance wherever and whenever you require it.
					You&lsquo;ll never be alone on this journey.
				</p>
			</Container>
		</>
	);
};
